import React, { useEffect } from 'react'
import { withRouter, useHistory, useLocation} from 'react-router-dom'
import { getUser } from '../../redux/actions/user'
import { useDispatch, useSelector } from 'react-redux'
import { isSuperAdmin } from '../../utils/helpers'

const isAuthenticated = (ComposedComponent) => {
  const Authenticated = (props) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()

    const { getUserState, user } = useSelector((state) => ({
      getUserState: state.user.getUser,
      user: state.user.user
    }))

    useEffect(() => {
      if (!getUserState.success) {
        dispatch(getUser())
      }
    }, [])

    useEffect(() => {
      if (getUserState.error !== false) {
        history.push('/login')
      }
    }, [getUserState.error])

    useEffect(() => {
      if (location.pathname.includes('configurator') && !isSuperAdmin(user)) {
        history.push(`/health-system/${user.healthSystem.tenant}`)
      }
    }, [location, user])

    return (
      <>
        {
          getUserState.loading 
            ? <div />
            :  <ComposedComponent {...props} />
        }
      </>
    )
  }

  return withRouter(Authenticated)
}

export default isAuthenticated
